<template>
  <b-modal ref="stoppageModal"
           id="stoppageModal"
           size="lg"
           :hide-footer="true"
           centered
           @close="$emit('close')">
    <template #modal-header>
        <div class="d-flex align-items-center col-12">
          <img src="https://static.zopone.com.br/img/logotipo/header/zopone.png" style="width: 45px" />
          <span class="modalTitle ml-auto">
            {{$lang.PCI.Stoppage.Title}}
          </span>
          <button class="close" @click="onHide">x</button>
        </div>
    </template>
    <div>
      <b-row class="m-3" v-if="!editing && workFinished">
        <b-col cols="12" class="text-center"><h5 class="bg-info"><strong>{{$lang.PCI.Stoppage.LabelRetroactive}}</strong></h5></b-col>
      </b-row>
      <b-row class="m-3" v-if="editing">
        <b-col cols="12" class="text-center"><h5 class="bg-danger"><strong>{{$lang.PCI.Stoppage.LabelEditing}}</strong></h5></b-col>
      </b-row>
      <b-row v-if="editing || !workStopped || workFinished">
        <b-col cols="6"><span>{{$lang.PCI.Stoppage.LabelDateStart}}</span></b-col>
      </b-row>
      <b-row class="mb-3 align-items-center" v-if="editing || !workStopped || workFinished">
        <b-col cols="6">
          <b-input type="date"
                   v-model="form.inicioParalisacao.value"
                   :required="form.inicioParalisacao.required"
                   :state="form.inicioParalisacao.state"/>
        </b-col>
      </b-row>
      <b-row v-if="editing || workStopped || workFinished">
        <b-col cols="6"><span>{{$lang.PCI.Stoppage.LabelDateEnd}}</span></b-col>
      </b-row>
      <b-row class="mb-3" v-if="editing || workStopped || workFinished">
        <b-col cols="6">
          <b-form-input type="date"
                        v-model="form.terminoParalisacao.value"
                        :required="form.terminoParalisacao.required"
                        :state="form.terminoParalisacao.state" />
        </b-col>
      </b-row>
      <b-row v-if="editing || !workStopped || workFinished">
        <b-col cols="12"><span>{{$lang.PCI.Stoppage.LabelResponsible}}</span></b-col>
      </b-row>
      <b-row class="mb-3" v-if="editing || !workStopped || workFinished">
        <b-col cols="6">
          <b-form-select v-model="form.responsavelParalisacao.value"
                         :required="form.responsavelParalisacao.required"
                         :state="form.responsavelParalisacao.state"
                         :options="form.responsavelParalisacao.options">
          </b-form-select>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12"><span>{{$lang.PCI.Stoppage.LabelObservation}}</span></b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-textarea v-model="form.observacao.newValue"
                          :required="form.observacao.required"
                          v-if="workStopped && !editing"
                          :state="form.observacao.state"
                          :max-rows="20">
          </b-form-textarea>
          <b-card class="p-0 m-0" v-if="workStopped && !editing">
            <pre>{{ form.observacao.value }}</pre>
          </b-card>
          <b-form-textarea v-model="form.observacao.value"
                          :required="form.observacao.required"
                          v-if="!workStopped || editing"
                          :state="form.observacao.state"
                          :max-rows="20">
          </b-form-textarea>
        </b-col>
      </b-row>
      <hr>
      <div id="div-buttons" class="d-flex justify-content-end mb-3">
        <button type="button" :disabled="!form.observacao" v-if="!editing && !workStopped" class="btn btn-third btn-sm" v-on:click="onStopWork()"><i class="fa fa-pause"></i> {{$lang.Common.Buttons.Save}}</button>
        <button type="button" v-if="!editing && workStopped" class="btn btn-third btn-sm" v-on:click="onRestartWork()"><i class="fa fa-play"></i> {{$lang.PCI.Stoppage.ButtonRestart}}</button>
        <button type="button" v-if="editing" class="btn btn-third btn-sm" v-on:click="onSave()"><i class="fa fa-check"></i> {{$lang.Common.Buttons.Save}}</button>
        <button type="button" v-if="editing" class="btn btn-third btn-sm ml-3" v-on:click="onClearForm()"><i class="fa fa-undo"></i> {{$lang.Common.Buttons.Back}}</button>
      </div>
    </div>

    <tables ref="tableGrid" class="col-mdEW-12 tabela"
            :columns="[$lang.PCI.Stoppage.Datatable.Start,
                      $lang.PCI.Stoppage.Datatable.End,
                      $lang.PCI.Stoppage.Datatable.Responsible,
                      $lang.PCI.Stoppage.Datatable.Account,
                      $lang.PCI.Stoppage.Datatable.Date,
                      $lang.PCI.Stoppage.Datatable.Observation,
                      $lang.Common.DataTable.Actions]"
            :showPaging="false"
            :showTipFooter="false"
            :showHeader="false">
      <tr v-for="(obj, idx) in this.objList" :key="obj.id">
        <table-column :IsCustom="true">
          <a href="#" @click="onEdit(obj)">
            <span style="cursor: pointer;">
              {{formatDate(obj.inicioParalisacao)}}
            </span>
          </a>
        </table-column>
        <table-column :IsCustom="true">
          <span>
            {{formatDate(obj.terminoParalisacao)}}
          </span>
        </table-column>
        <table-column :IsCustom="true">
          {{obj.responsavelParalisacao === 0 ? 'CLIENTE' : obj.responsavelParalisacao === 1 ? 'ZOPONE' : 'EMBARGADO'}}
        </table-column>
        <table-column :IsCustom="true">
          <span>
            {{obj.nomeContaAcao}}
          </span>
        </table-column>
        <table-column :IsCustom="true">
          <span>
            {{obj.dataAcaoFormatada}}
          </span>
        </table-column>
        <table-column :IsCustom="true">
          <b-popover :target="'obs' + idx" triggers="hover" boundary="window" placement="topleft">
            <pre>{{ obj.observacao }}</pre>
          </b-popover>
          <span :id="'obs' + idx" style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden; width: 10rem; display: block;">
            {{obj.observacao}}
          </span>
        </table-column>
        <table-column :IsActionsButtons="true" :HasChange="false" @Delete="onDelete(obj)"></table-column>
      </tr>
    </tables>
  </b-modal>
</template>

<script>
import TableColumn from '@/components/forms/TableColumn.vue'
import Tables from '@/components/forms/Tables.vue'
import WorkPCIRepository from '@/shared/http/repositories/pci/workpci'
import roles from '@/shared/utils/roles'
import { loading, toast } from '@/shared/utils/UIHelper'
import PermisionMixin from '@/store/module/permission/mixin'
import moment from 'moment'
import stoppageForm from './stoppage-form'

export default {
  name: 'Stoppage',
  mixins: [PermisionMixin],
  components: {
    Tables,
    TableColumn
  },
  data () {
    return {
      form: stoppageForm,
      objList: [],
      pci: {},
      roles: roles,
      editing: false
    }
  },
  computed: {
    workStopped () {
      return this.pci.paralisacaoInicio && !this.pci.paralisacaoRetorno
    },
    workFinished () {
      return Boolean(this.pci.terminoObraParalisacao)
    }
  },
  methods: {
    onHide () {
      this.$refs['stoppageModal'].hide()
    },
    onClearForm () {
      this.editing = false

      this.form.terminoParalisacao.required = this.workFinished
      this.form.inicioParalisacao.value = null
      this.form.terminoParalisacao.value = null
      this.form.responsavelParalisacao.value = 0
      this.form.observacao.value = null

      this.form.observacao.newValue = null

      this.form.inicioParalisacao.state = null
      this.form.terminoParalisacao.state = null
      this.form.responsavelParalisacao.state = null
      this.form.observacao.state = null

      if (this.workStopped) {
        this.form.inicioParalisacao.value = this.pci.paralisacaoInicio
        this.form.terminoParalisacao.value = new Date().toISOString().substring(0, 10)
      } else {
        this.form.inicioParalisacao.value = new Date().toISOString().substring(0, 10)
        this.form.terminoParalisacao.value = null
      }
      // if (!this.workFinished) {
      // }
      if (this.workStopped) { // && !this.workFinished) {
        this.form.observacao.value = this.objList.length ? this.objList[0].observacao : ''
      }
    },
    onValidate () {
      let result = true
      let msg = this.$lang.Common.Alerts.RequiredField
      this.form.inicioParalisacao.state = null
      this.form.terminoParalisacao.state = null
      const today = new Date()
      today.setHours(0)
      today.setMinutes(0)
      today.setSeconds(0)
      today.setMilliseconds(0)
      if (!this.form.inicioParalisacao.value) {
        this.form.inicioParalisacao.state = false
        result = false
      } else if (moment(this.form.inicioParalisacao.value).toDate() > today) {
        this.form.inicioParalisacao.state = false
        result = false
        msg = this.$lang.PCI.Stoppage.WarningDateGreatherToday
      }

      if (this.form.terminoParalisacao.required && !this.form.terminoParalisacao.value) {
        this.form.terminoParalisacao.state = false
        result = false
      } else if (moment(this.form.terminoParalisacao.value).toDate() > today) {
        this.form.terminoParalisacao.state = false
        result = false
        msg = this.$lang.PCI.Stoppage.WarningDateGreatherToday
      }

      if (!this.form.observacao.value) {
        this.form.observacao.state = false
        result = false
      }

      if (!result) toast.error(msg)
      else {
        msg = this.$lang.PCI.Stoppage.WarningDates

        if (this.form.inicioParalisacao.value && this.form.inicioParalisacao.value < this.pci.inicioReal) {
          this.form.inicioParalisacao.state = false
          result = false
        }

        if (this.form.inicioParalisacao.value && this.pci.terminoReal && this.form.inicioParalisacao.value > this.pci.terminoReal) {
          this.form.inicioParalisacao.state = false
          result = false
        }

        if (this.form.terminoParalisacao.value && this.pci.terminoReal && this.form.terminoParalisacao.value > this.pci.terminoReal) {
          this.form.terminoParalisacao.state = false
          result = false
        }

        if (!result) toast.error(msg)
      }

      return result
    },
    show (data) {
      this.pci = data

      this.onClearForm()

      this.$nextTick(() => {
        this.$refs['stoppageModal'].show()
        WorkPCIRepository.GetStoppages(this.pci.obraId)
          .then((response) => {
            this.objList = response.data.data
            if (!this.workFinished && this.workStopped) {
              this.form.responsavelParalisacao.value = this.objList[0].responsavelParalisacao
              this.form.observacao.value = this.objList[0].observacao
            }
            if (this.workFinished && this.workStopped) {
              this.form.inicioParalisacao.value = this.objList[0].inicioParalisacao ? this.objList[0].inicioParalisacao.substring(0, 10) : null
              this.form.terminoParalisacao.value = this.objList[0].terminoParalisacao ? this.objList[0].terminoParalisacao.substring(0, 10) : null
              this.form.responsavelParalisacao.value = this.objList[0].responsavelParalisacao
              this.form.observacao.value = this.objList[0].observacao
              this.editing = true
            }
          })
          .catch(() => {
            toast.error(this.$lang.Common.Alerts.Error)
          })
          .finally(() => {
            loading.close()
          })
      })
    },
    onEdit (obj) {
      this.form.id = obj.id
      this.form.inicioParalisacao.value = obj.inicioParalisacao ? obj.inicioParalisacao.substring(0, 10) : null
      this.form.terminoParalisacao.value = obj.terminoParalisacao ? obj.terminoParalisacao.substring(0, 10) : null
      this.form.responsavelParalisacao.value = obj.responsavelParalisacao
      this.form.observacao.value = obj.observacao
      this.form.obraID.value = obj.obraID
      this.editing = true
    },
    onSave () {
      if (!this.onValidate()) {
        return
      }

      loading.push()
      const stoppage = {
        id: this.form.id,
        inicioParalisacao: this.form.inicioParalisacao.value,
        terminoParalisacao: this.form.terminoParalisacao.value,
        responsavelParalisacao: this.form.responsavelParalisacao.value,
        observacao: this.form.observacao.value,
        obraID: this.form.obraID.value
      }
      WorkPCIRepository.UpdateStoppage(stoppage)
        .then((response) => {
          if (response.data.code > 0) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.$emit('update')
          } else {
            toast.error(response.data.message)
          }
        })
        .catch(() => {
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => {
          loading.close()
          this.showStoppage = false
        })
    },
    onDelete (obj) {
      loading.push()
      WorkPCIRepository.DeleteStoppage(obj.id)
        .then(response => {
          if (response.data.code > 0) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.$emit('update')
          } else {
            toast.error(response.data.message)
          }
        })
        .catch(err => {
          console.log(err)
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => loading.close())
    },
    onStopWork () {
      if (!this.onValidate()) {
        return
      }
      const stoppage = {
        inicioParalisacao: this.form.inicioParalisacao.value,
        terminoParalisacao: this.form.terminoParalisacao.value,
        responsavelParalisacao: this.form.responsavelParalisacao.value,
        observacao: this.form.observacao.value
      }
      loading.push()
      WorkPCIRepository.StopWork(this.pci.obraId, stoppage)
        .then((response) => {
          if (response.data.code > 0) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.$emit('update')
          } else {
            toast.error(response.data.message)
          }
        })
        .catch(() => {
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => {
          loading.close()
          this.showStoppage = false
        })
    },
    onRestartWork () {
      const stoppage = {
        terminoParalisacao: this.form.terminoParalisacao.value,
        observacao: (this.form.observacao.newValue ? this.form.observacao.newValue + '\n' : '') + this.form.observacao.value
      }
      if (!this.onValidate()) {
        return
      }
      loading.push()
      WorkPCIRepository.RestartWork(this.pci.obraId, stoppage)
        .then((response) => {
          if (response.data.code > 0) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.$emit('update')
          } else {
            toast.error(response.data.message)
          }
        })
        .catch(() => {
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => {
          loading.close()
          this.showStoppage = false
        })
    },
    formatDate (value) {
      if (value) {
        const dt = new Date(value)
        return dt.toLocaleDateString()
      }
    }
  }
}
</script>

<style scoped>
div#stoppageModal td:has(.rejected) {
    background-color: whitesmoke;
}
td * {
  cursor: default;
}
.rejected {
  color: red;
}
* >>> .modal-header {
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
}
* >>> .modal-body {
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
  scroll-snap-type: y proximity;
}
* >>> .modal-footer {
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
}
* >>> .modal-content {
  border-radius: 25px;
}
* >>> div.popover {
  max-width: 40vw !important;
  max-height: 40vh;
}

* >>> div.popover-body {
  max-width: 40vw !important;
  max-height: 40vh;
  overflow-y: auto;
  overflow-x: hidden;
}

div.popover pre {
  overflow-wrap: break-word;
  word-break: break-all;
  white-space: pre-wrap;
  font-size: var(--ag-font-size);
  font-family: "Verdana","Segoe UI","Open Sans",Helvetica,Arial,sans-serif;
  max-width: 40vw !important;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/stoppage/stoppage.vue